require('./accountDirectDebitConfirmationStep.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

//@helpers
const { FormattedText } = require('core/i18n').i18n;

//@commons
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');

//@constants
const { ACCOUNT_DIRECT_DEBIT_ID } = require('constants/operationTypes');

class AccountDirectDebitConfirmationStep extends React.Component {
    render() {
        const { immAccount } = this.props;
        const operationParams = {
            originAccount: immAccount.getIn(['ibanComplex','codbban'])
        }

        return (
            <div className="account-direct-debit-confirmation-step">
                <h2 className="account-direct-debit-confirmation-step__title">
                    <FormattedText value="accountDirectDebitConfirmationStep-title"/>
                </h2>
                <SignaturePattern
                    operationType={ACCOUNT_DIRECT_DEBIT_ID}
                    operationParams={operationParams}
                />
            </div>
        );
    }
}

AccountDirectDebitConfirmationStep.propTypes = {
    immAccount: PropTypes.object.isRequired
};
module.exports = AccountDirectDebitConfirmationStep;
